<template>
    <div class="card mb-3" :class="{ featured: featured }">
        <div class="card-body">
            <div class="row">
                <div class="col-sm-5 col-md-4 image-wrapper" v-if="hasImageSlot">
                    <slot name="image" />
                </div>
                <div class="col-sm-7 col-md-8 content">
                    <span class="badge badge-primary" v-if="featured">Featured</span>
                    <slot name="content"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'card-template',

    props: {
        featured: {
            type: Boolean,
            default: false,
        }
    },

    computed: {
        hasImageSlot() {
            return !!this.$slots.image
        },
    },
}
</script>

<style scoped>
    .card {
        cursor: pointer;
        border-radius: 5px;
    }
    .badge {
        font-size: 15px;
        margin-bottom: 10px;
    }
    img {
        width: 100%;
        max-width: 100%;
        margin-bottom: 15px
    }
    .card-title {
        margin-bottom: 5px;
    }
    time {
        font-size: 15px;
        margin-bottom: 0.5rem;
        display: block;
    }
    .featured {
        background: rgba(131, 135, 172, 0.46);
    }
    p {
        margin-bottom: 0.4rem;
    }

    @media (min-width: 768px) { 
        .card img {
            margin-bottom: 0;
        }
    }
</style>